import { render, staticRenderFns } from "./Create-Opportunity.vue?vue&type=template&id=00b7c315&scoped=true"
import script from "./Create-Opportunity.vue?vue&type=script&lang=js"
export * from "./Create-Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Create-Opportunity.vue?vue&type=style&index=0&id=00b7c315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7c315",
  null
  
)

export default component.exports